import { useCurrentStateAndParams } from "@uirouter/react";

import { swSettings } from "app/common/services/swSettings";
import DurationService from "app/services/DurationService";

// Search Overview data is snapshot-based and only valid within this component's window.
// The interval must be resolved against this component and not the globally-active section:
// while navigating away, the active section flips to one with a wider (non-snapshot) window
// before the page unmounts, so resolving against it would request an out-of-range interval
// and 400. Both the competitive-research and sales-intelligence routes use this config id.
const SEARCH_OVERVIEW_COMPONENT_ID = "WebAnalysisSearchOverview";

const useTrafficSearchApiParams = () => {
    const { params } = useCurrentStateAndParams();
    const { duration, country, webSource, key, comparedDuration } = params;

    const componentId = swSettings.components?.[SEARCH_OVERVIEW_COMPONENT_ID]
        ? SEARCH_OVERVIEW_COMPONENT_ID
        : undefined;
    const { from, to } = DurationService.getDurationData(duration, comparedDuration, componentId).forAPI;

    const trafficSearchApiParams = {
        country,
        to,
        from,
        webSource,
        keys: key,
        includeSubDomains: "true",
    };
    return { trafficSearchApiParams };
};

export default useTrafficSearchApiParams;
